import { render, staticRenderFns } from "./editConference.vue?vue&type=template&id=6ba0f67a&scoped=true&lang=pug&"
import script from "./editConference.vue?vue&type=script&lang=js&"
export * from "./editConference.vue?vue&type=script&lang=js&"
import style0 from "./editConference.vue?vue&type=style&index=0&id=6ba0f67a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0f67a",
  null
  
)

export default component.exports